import productCardIni from "../cookieStorage/productCardIni.js";
import store from "../store";
import {fetchVisitorByUUID} from "../reduxLib/visitorLib";
import {
    addItemToShoppingCard,
    fetchShoppingCardByVisitorRelID,
    removeItemFromShoppingCard
} from "../reduxLib/shoppingcardLib";

function addToCart(product,qt) {
    const cart = productCardIni();

    console.log("addToCart called with product:", product, "and quantity:", qt);

    const qty = Math.max(1, Number(qt) || 1);
    const idx = cart.findIndex(p => p.id === product.id && p.color === product.color);



    let qunt=0;
    if (idx >= 0) {
        cart[idx].quantity += qty;

        store
            .dispatch(fetchVisitorByUUID(localStorage.getItem("vid")))
            .unwrap()
            .then(visitor => {
                console.log("Visitor:", visitor);
                return store
                    .dispatch(fetchShoppingCardByVisitorRelID(visitor.visitorID))
                    .unwrap();
            })
            .then(shoppingCard => {
                console.log("ShoppingCard:", shoppingCard);
                return store
                    .dispatch(
                        removeItemFromShoppingCard({
                            cardId: shoppingCard.shoppingCardId,
                            itemId: product.id,
                        })
                    )
                    .unwrap();
            })
            .then(shoppingCard => {
                console.log("ShoppingCard add:", shoppingCard);
                return store
                    .dispatch(
                        addItemToShoppingCard({
                            cardId: shoppingCard.shoppingCardId,
                            itemId: product.id,
                            quantity: cart[idx].quantity,
                        })
                    )
                    .unwrap();
            })
            .then(result => {
                console.log("AddItem result:", result);
            })
            .catch(err => {
                console.error("ERROR:", err);
            });

    } else {
        cart.push({
            id: product.id,
            name: product.name,
            image: product.image,
            price: product.price,
            description: product.description,
            color: product.color,
            quantity: qty
        });
        store
            .dispatch(fetchVisitorByUUID(localStorage.getItem("vid")))
            .unwrap()
            .then(visitor => {
                console.log("Visitor:", visitor);
                return store
                    .dispatch(fetchShoppingCardByVisitorRelID(visitor.visitorID))
                    .unwrap();
            })
            .then(shoppingCard => {
                console.log("ShoppingCard:", shoppingCard);
                return store
                    .dispatch(
                        addItemToShoppingCard({
                            cardId: shoppingCard.shoppingCardId,
                            itemId: product.id,
                            quantity: qty,
                        })
                    )
                    .unwrap();
            })
            .then(result => {
                console.log("AddItem result:", result);
            })
            .catch(err => {
                console.error("ERROR:", err);
            });
    }

    localStorage.setItem("productCard", JSON.stringify(cart));
}
export default addToCart;
